import { render, staticRenderFns } from "./AccordionSelectCategories.vue?vue&type=template&id=461818bc"
import script from "./AccordionSelectCategories.vue?vue&type=script&lang=js"
export * from "./AccordionSelectCategories.vue?vue&type=script&lang=js"
import style0 from "./AccordionSelectCategories.vue?vue&type=style&index=0&id=461818bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports